import styled from "styled-components";
import {SIZES} from "@/components/constants";
import {useMediaQuery} from "react-responsive";

const FormConfirm = ({active, setConfirmState}) => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    return(
        <FormConfirmWrap className={`${active ? "active" : ""}`}>
            <div className={"confirm-inner"}>
                <div className={"title"}>문의가 완료되었습니다.</div>
                <div className={"desc"}>
                    {
                        !isTablet ?
                            <>
                                빠른시일내에 작성하신 연락처와 이메일로 회신드리겠습니다.<br />
                                감사합니다.
                            </>
                            :
                            <>
                                빠른시일내에 작성하신<br/>
                                연락처와 이메일로 회신드리겠습니다.<br/>
                                감사합니다.
                            </>
                    }
                </div>
                <div className={"confirm-btn"} onClick={() => {
                    setConfirmState(false)
                }}>확인</div>
            </div>
            <div className={"confirm-dimmed"}/>
        </FormConfirmWrap>
    )
};
const FormConfirmWrap = styled.div`


    

    .confirm-dimmed{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 60;
        display: none;
    }
    .confirm-inner{
        transition: all .2s ease-in-out;
        opacity: 0;
        visibility: hidden;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 61;
        box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.08), 0 4px 16px -4px rgba(0, 0, 0, 0.20);
        background-color: #fff;
        padding: 40px 20px 20px;
        width: 480px;
        border-radius: 20px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            line-height: 30px; 
            letter-spacing: -0.4px;
            margin-bottom: 10px;
        }
        .desc{
            font-size: 18px;
            text-align: center;
            font-weight: 400;
            line-height: 28px;
            margin-bottom: 40px;
        }
        .confirm-btn{
            width: 200px;
            height: 44px;
            background: #23203B;
            border-radius: 8px;
            cursor: pointer;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0.02em;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .confirm-inner{
            width: calc(100% - 20px);
            .desc{
                margin-bottom: 25px;
            }
        }
    }
    &.active{
        .confirm-dimmed{
            display: block;
        }
        .confirm-inner{
            opacity: 1;
            visibility: visible;
        }
    }
`
export default FormConfirm;